import {Project} from '../types';

export const projects: Project[] = [
    {
        title: "Namleah Tech",
        description: "Comprehensive food delivery and grocery platform connecting consumers directly with food companies and local stores",
        tech: ["Google Maps", "WebSockets", "Real-time Tracking"],
        image: process.env.PUBLIC_URL + "/projects/namleah.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.extremetech.namleahtech.client",
        appStore: "https://apps.apple.com/us/app/نملية-تك/id6742736343",
        year: "2025",
        company: "Extreme Tech",
    },
    {
        title: "APC Prime",
        description: "Banking management app linked to Arab Platform Capital enabling account management, transactions, and comprehensive banking services",
        tech: ["Secure APIs", "Biometric Auth", "Banking"],
        image: process.env.PUBLIC_URL + "/projects/apc-prime.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.app.apcprime",
        appStore: "https://apps.apple.com/us/app/apc-prime/id6740485255",
        year: "2025",
        company: "Logic Software Development",
    },
    {
        title: "Zero-Car",
        description: "Automotive marketplace for buying and renting cars with listings from global agencies and advanced search features",
        tech: ["Google Maps", "REST APIs", "Marketplace"],
        image: process.env.PUBLIC_URL + "/projects/zero-car.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.zero.cars",
        appStore: "https://apps.apple.com/us/app/zero-cars/id6737797931",
        year: "2025",
        company: "Logic Software Development",
    },
    {
        title: "Al Mutawasit E-Commerce",
        description: "Robust multi-vendor marketplace platform connecting sellers and buyers with smooth, secure experience for listing, purchasing, and delivering diverse product categories",
        tech: ["Multi-vendor", "Payment Gateway", "Delivery Tracking"],
        image: process.env.PUBLIC_URL + "/projects/al-mutawasit.svg",
        behance: "https://www.behance.net/gallery/almutawasit-ecommerce",
        year: "2022",
        company: "Micro-Tech",
    },
    {
        title: "Rehlatiue",
        description: "UAE tourism platform for booking and managing tourism activities with real-time availability and payment processing",
        tech: ["Payment Gateway", "Booking System", "Multi-language"],
        image: process.env.PUBLIC_URL + "/projects/rehlatiue.svg",
        playStore: "#",
        year: "2025",
        company: "Micro-Tech",
    },
    {
        title: "Lumiere Vogue E-Commerce",
        description: "Exclusive luxury shopping destination specializing in high-end premium goods and prestigious brands with curated collection and premium user experience",
        tech: ["E-Commerce", "Payment Gateway", "Premium UI"],
        image: process.env.PUBLIC_URL + "/projects/lumiere-vogue.svg",
        behance: "https://www.behance.net/gallery/lumiere-vogue-ecommerce",
        year: "2022",
        company: "Micro-Tech",
    },
    {
        title: "Wiki-Exporter",
        description: "Comprehensive trade management platform featuring import/export services and interactive educational content to support international business operations",
        tech: ["Trade Management", "Education Platform", "REST APIs"],
        image: process.env.PUBLIC_URL + "/projects/wiki-exporter.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.wikiexporter.app",
        year: "2024",
        company: "Logic Software Development",
    },
    {
        title: "MT Store",
        description: "Feature-rich e-commerce platform with attractive UI/UX design offering seamless shopping experience for diverse product categories with advanced search and payment options",
        tech: ["Stripe", "E-Commerce", "REST APIs"],
        image: process.env.PUBLIC_URL + "/projects/mt-store.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.mtstore.app",
        appStore: "https://apps.apple.com/app/mtstore/id123456789",
        year: "2024",
        company: "Logic Software Development",
    },
    {
        title: "El Mensaje Eterno",
        description: "Comprehensive Islamic application featuring Holy Quran with audio recitations, Prophet's hadiths, daily notes, supplications, and educational content for spiritual learning",
        tech: ["Audio Streaming", "Offline Mode", "Islamic APIs"],
        image: process.env.PUBLIC_URL + "/projects/el-mensaje-eterno.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.elmensajeeterno.app",
        year: "2023",
        company: "Micro-Tech",
    },
    {
        title: "Oliver System",
        description: "Olive oil mill management system enabling appointment booking, olive status monitoring, customer transaction management, and buying/selling operations",
        tech: ["Appointments", "Inventory", "Transactions"],
        image: process.env.PUBLIC_URL + "/projects/oliver-system.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.oliversystem.app",
        year: "2023",
        company: "Micro-Tech",
    },
    {
        title: "Constructor",
        description: "Construction management platform facilitating project contract creation, requirement tracking, task assignment to employees, and comprehensive client interaction management",
        tech: ["Project Management", "Task Assignment", "Client Portal"],
        image: process.env.PUBLIC_URL + "/projects/constructor.svg",
        playStore: "https://play.google.com/store/apps/details?id=com.constructor.app",
        year: "2022",
        company: "Micro-Tech",
    },
];